import Vue from 'vue'
import consts from '@/consts'
import {createActionHelpers} from 'vuex-loading'
import i18n from '@/translator'

const {startLoading, endLoading} = createActionHelpers({
  moduleName: 'loading'
})

function getTracks (genreFilter, perPage, commit, textToFilter) {
  let url = Vue.http.get(consts.API_BASE_URL + `/tracks/byGenre/${genreFilter}/${perPage}/${textToFilter}`)
  const promise = url
  promise.then((response) => {
    if (response.data.status === 'ok') {
      commit('incrementFrom', 1)
    }
  })
  return promise
}

// emazzu, inicializamos array para genero principal
//
const initialStates = function () {
  return {
    error: '',
    genres: [],
    genresMain: [],
    // genresSecon: [],
    isTrackUploaded: false,
    allTracks: [],
    noMoreResults: false,
    results: [],
    // from: 0,
    perPage: 1,
    genreFilter: 0,
    discoverMainGenre: null,
    discoverSeconGenre: null,
    links: Object,
    promotion: [],
    ads: [],
    prices: []
  }
}

const mutations = {
  error (state, value) {
    state.isLoggedIn = false
    state.error = value['message']
  },
  resetError (state) {
    state.error = ''
  },
  // emazzu, asignamos array de json con genero principal
  //
  getGenresMain (state, value) {
    state.genresMain = value
  },
  isTrackUploaded (state, value) {
    state.isTrackUploaded = value
  },
  setAllTracks (state, value) {
    state.allTracks = value
  },
  appendperPage (state, value) {
    state.allTracks.push(...value)
  },
  incrementFrom (state, value) {
    state.perPage += value
  },
  setGenreFilter (state, value) {
    state.genreFilter = value
  },
  setDiscoverMainGenre (state, value) {
    state.discoverMainGenre = value
  },
  setDiscoverSeconGenre (state, value) {
    state.discoverSeconGenre = value
  },
  setFrom (state, value) {
    state.perPage = value
  },
  noMoreResults (state, value) {
    state.noMoreResults = value
  },
  setLinks (state, value) {
    state.links = value
  },
  setPromotion (state, value) {
    state.promotion = value
  },
  setAds (state, value) {
    for (var i = 0; i < value.audios.length; i++) {
      state.ads[i] = {path: value.path, file: value.audios[i], isAd: true}
    }
  },
  setPrices (state, value) {
    state.prices = value
  }

}

const actions = {

  // emazzu, start, se ejecuta al hacer clic en la solapa DESCUBRIR
  getAll ({commit, dispatch, state}, textToFilter = null) {
    startLoading(dispatch, 'track getAll')
    commit('noMoreResults', false)
    return new Promise((resolve, reject) => {
      getTracks(state.genreFilter, state.perPage, commit, textToFilter)
        .then(
          function (response) {
            endLoading(dispatch, 'track getAll')
            if (response.body.status === true) {
              commit('setAllTracks', response.body.data)
              resolve(response.body.data)
            } else {
              commit('setAllTracks', null)
              commit('error', {error: true, message: i18n.t('error.store.tracks')})
              reject(new Error(i18n.t('error.store.network')))
            }
          },
          function () {
            endLoading(dispatch, 'track getAll')
            commit('error', {error: true, message: i18n.t('error.store.network')})
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },
  // emazzu, end, se ejecuta al hacer clic en la solapa DESCUBRIR

  // emazzu, start, se ejecuta al deslizarse hacia abajo para traer mas datos a demanda
  loadMore ({commit, dispatch, state}, textToFilter = null) {
    if (textToFilter === '') {
      textToFilter = null
    }
    startLoading(dispatch, 'track loadMore')
    commit('noMoreResults', false)
    commit('incrementFrom', 1)
    return new Promise((resolve, reject) => {
      getTracks(state.genreFilter, state.perPage, commit, textToFilter)
        .then(
          function (response) {
            endLoading(dispatch, 'track loadMore')
            if (response.body.status === true) {
              if (response.body.data.length > 0) {
                commit('appendperPage', response.body.data)
              } else {
                commit('noMoreResults', true)
              }
              resolve(response.body.data)
            } else if (response.body.status === false && response.body.error.message === 'Track no encontrado') {
              commit('noMoreResults', true)
              resolve(response.body.error.message)
            } else {
              commit('error', {error: true, message: i18n.t('error.store.tracks')})
              reject(new Error(i18n.t('error.store.tracks')))
            }
          },
          function () {
            endLoading(dispatch, 'track loadMore')
            commit('error', {error: true, message: i18n.t('error.store.network')})
            reject(new Error(i18n.t('error.store.network')))
          }
        )
    })
  },
  // emazzu, end, se ejecuta al deslizarse hacia abajo para traer mas datos a demanda

  setFrom ({commit}, value) {
    commit('setFrom', value)
  },

  setGenreFilter ({commit}, value) {
    commit('setGenreFilter', value)
  },

  getConvertedValues ({ commit }, value) {
    return new Promise((resolve, reject) => {
      var trackId = null
      if (value.track) {
        trackId = value.track.id
      }
      Vue.http.post(consts.API_BASE_URL + '/getTrackValues', {
        track: trackId,
        currency: value.toCurrency
      }).then(
        function (response) {
          commit('setPrices', response.body.values)
          if (response.body.status === true) {
            resolve(response.body)
          } else {
            reject(new Error(response.body.error))
          }
        },
        function () {
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  getBuyLink ({commit, dispatch}, value) {
    startLoading(dispatch, 'track getBuyLink')
    return Vue.http.post(consts.API_BASE_URL + '/payment/getPayment', {
      track: value.track.id,
      amount: value.value || 0,
      currency: value.currency || null,
      gateway: value.gateway || null,
      description: value.description || null
    }).then(
      function (response) {
        endLoading(dispatch, 'track getBuyLink')
        if (response.body.status === true) {
          if (response.body.gateway !== 'paypal') {
            return Promise.resolve(response.body.next_url)
          } else {
            return response.body.status
          }
        } else {
          return Promise.reject(new Error(response.body.error))
        }
      },
      function () {
        endLoading(dispatch, 'track getBuyLink')
        return Promise.reject(new Error(i18n.t('error.store.network')))
      })
  },

  getPromotion ({commit, dispatch}) {
    startLoading(dispatch, 'track getPromotion')
    return new Promise((resolve, reject) => {
      Vue.http.get(consts.API_BASE_URL + '/tracks/promotion').then(
        function (response) {
          if (response.body.status === 'ok') {
            endLoading(dispatch, 'track getPromotion')
            commit('setPromotion', response.body.data.tracks)
            commit('setAds', response.body.data.speechs)
            resolve()
          }
        },
        function () {
          endLoading(dispatch, 'track getPromotion')
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  setLike ({commit}, value) {
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/tracks/setLike', {
        track_id: value
      }).then(
        function (response) {
          if (response.body.status === 'ok') {
            resolve()
          }
        },
        function () {
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  resetError ({commit}) {
    commit('resetError')
  },

  uploadAlbum ({commit, dispatch}, values) {
    startLoading(dispatch, 'track editTrack')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/tracks/uploadAlbum', {
        values
      }).then(
        function (response) {
          endLoading(dispatch, 'track editTrack')
          if (response.body.status === true) {
            commit('isTrackUploaded', true)
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.trackUpload')})
            reject(new Error(i18n.t('error.albumUpload')))
          }
        },
        function () {
          endLoading(dispatch, 'track editTrack')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  editTrack ({commit, dispatch}, value) {
    let picture = value.picture.split(/\/uploads\/tracks\//gi).reverse()[0]
    startLoading(dispatch, 'track editTrack')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/tracks/edit/' + value.id, {
        comments: value.coments,
        id_music_type: value.id_music_type,
        new_release: value.new_release,
        picture: picture,
        tags: value.tags,
        title: value.title,
        id_lisense: value.license,
        minPrice: value.min_price,
        recommendedGenre: value.recommendedGenre,
        iswc: value.iswc,
        credits: value.credits
      }).then(
        function (response) {
          endLoading(dispatch, 'track editTrack')
          if (response.body.data === 'saved') {
            commit('isTrackUploaded', true)
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.trackUpload')})
            reject(new Error(i18n.t('error.trackUpload')))
          }
        },
        function () {
          endLoading(dispatch, 'track editTrack')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },
  // emazzu, devolvemos array de json con genero principal
  //
  getGenresMain ({commit, dispatch}, withTracksFilter = false) {
    startLoading(dispatch, 'track getGenresMain')
    return new Promise((resolve, reject) => {
      let url = consts.API_BASE_URL + '/genres/'
      if (withTracksFilter) {
        url = consts.API_BASE_URL + '/genres/?withTrackFilter=1'
      }
      Vue.http.get(url).then(
        function (response) {
          endLoading(dispatch, 'track getGenresMain')
          if (response.body.status === true) {
            let mainGenre = response.body.data.sort(function (a, b) {
              if (a.name > b.name) {
                return 1
              }
              if (a.name < b.name) {
                return -1
              }
              // a must be equal to b
              return 0
            })
            commit('getGenresMain', mainGenre)
            resolve()
          }
        },
        function () {
          endLoading(dispatch, 'track getGenresMain')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  setTrackUploaded ({commit}, value) {
    commit('isTrackUploaded', value)
  },

  delete ({commit, dispatch}, value) {
    startLoading(dispatch, 'track delete')
    return new Promise((resolve, reject) => {
      Vue.http.post(consts.API_BASE_URL + '/tracks/del', {
        track_id: value
      }).then(
        function (response) {
          if (response.body.status === 'ok' && response.body.data === 'deleted') {
            dispatch('user/getMyTracks', null, {root: true})
            endLoading(dispatch, 'track delete')
            resolve()
          } else {
            commit('error', {error: true, message: i18n.t('error.store.deleteTrack')})
            reject(new Error(i18n.t('error.store.deleteTrack')))
          }
        },
        function () {
          endLoading(dispatch, 'track delete')
          commit('error', {error: true, message: i18n.t('error.store.network')})
          reject(new Error(i18n.t('error.store.network')))
        })
    })
  },

  getTrack ({commit, dispatch}, id) {
    startLoading(dispatch, 'track getTrack')
    return Vue.http.get(consts.API_BASE_URL + '/tracks/' + id).then((response) => {
      endLoading(dispatch, 'track getTrack')
      if (response.body.status) {
        return Promise.resolve({canEdit: response.body.can_edit, track: response.body.data})
      } else {
        return Promise.reject(new Error(response.body.error.message))
      }
    }).catch(e => {
      let message = e.message ? e.message : i18n.t('error.store.network')
      endLoading(dispatch, 'track getTrack')
      return Promise.reject(new Error(message))
    })
  },

  storeReproduction ({commit, dispatch}, value) {
    return Vue.http.post(consts.API_BASE_URL + '/tracks/reproduction', {
      track_id: value.id
    }).then((response) => {
      if (response.body.status) {
        Promise.resolve()
      } else {
        Promise.reject(new Error(response.body.error.message))
      }
    }).catch((e) => {
      if (e.message) {
        Promise.reject(new Error(e.message ? e.message : i18n.t('error.store.network')))
      }
    })
  },

  setMyTrackOrder ({commit, dispatch}, value) {
    return Vue.http.post(consts.API_BASE_URL + '/tracks/reorderArtistTracks', {
      artist_id: value.artist_id,
      reorder: value.reorder
    }).then((response) => {
      if (response.body.status) {
        return response.body.status
      } else {
        Promise.reject(new Error(response.body.error.message))
      }
    }).catch((e) => {
      if (e.message) {
        Promise.reject(new Error(e.message ? e.message : i18n.t('error.store.network')))
      }
    })
  }
}

const getters = {
  error: state => {
    return state.error
  },
  genres: state => {
    return state.genres
  },
  genresMain: state => {
    return state.genresMain
  },
  isTrackUploaded: state => {
    return state.isTrackUploaded
  },
  allTracks: state => {
    return state.allTracks
  },
  genreFilter: state => {
    return state.genreFilter
  },
  discoverMainGenre: state => {
    return state.discoverMainGenre
  },
  discoverSeconGenre: state => {
    return state.discoverSeconGenre
  },
  noMoreResults: state => {
    return state.noMoreResults
  },
  links: state => {
    return state.links
  },
  promotion: state => {
    return state.promotion
  },
  ads: state => {
    return state.ads
  },
  prices: state => {
    return state.prices
  }
}

const track = {
  namespaced: true,
  initialStates,
  state: initialStates(),
  mutations: mutations,
  actions: actions,
  getters: getters
}

export default track



// WEBPACK FOOTER //
// ./src/store/modules/track.js